import React, { useRef, useEffect } from "react"
import { createRoot } from "react-dom/client"
import { useReactToPrint } from "react-to-print"

export const handlePrint = ({ component, isLandscape }: { component: React.ReactElement; isLandscape?: boolean }) => {
  const container = document.createElement("div")
  container.style.position = "absolute"
  container.style.top = "-9999px"
  document.body.appendChild(container)

  const PrintWrapper = () => {
    const ref = useRef<HTMLDivElement>(null)

    const print = useReactToPrint({
      content: () => ref.current,
      onAfterPrint: () => {
        setTimeout(() => {
          document.body.removeChild(container)
        }, 100)
      },
      removeAfterPrint: true,
    })

    useEffect(() => {
      setTimeout(() => {
        print()
      }, 1)
    }, [])

    return (
      <>
        {isLandscape && <style>{`@media print { @page { size: A4 landscape; } }`}</style>}
        <div ref={ref}>{component}</div>
      </>
    )
  }

  createRoot(container).render(<PrintWrapper />)
}
